const CHANGE_ATTRIBUTE = 'realhub/admin/pageBuilderSettings/CHANGE_ATTRIBUTE'

// Initial State
const initialState = {
  selectedAttributesPanel: 'details',
}

// Actions
export function changeAttribute(name, value){
  return {
    type: CHANGE_ATTRIBUTE,
    name,
    value,
  }
}

// Reducer
export default function reducer(state = initialState, action = {}){
  const { name, type, value } = action

  switch (type){
    case CHANGE_ATTRIBUTE:{
      return {
        ...state,
        [name]: value,
      }
    }
    default:
      return state
  }
}
